import type { FC } from 'react';
import { lazy } from 'react';
import type { TransactionKey } from '../locales';

const Captcha = lazy(() => import('./captcha'));
const Connecting = lazy(() => import('./connecting'));
const Connectors = lazy(() => import('./connectors'));
const DownloadApp = lazy(() => import('./downloadApp'));
const LoginPasskey = lazy(() => import('./loginPasskey'));
const PasskeySetup = lazy(() => import('./passkeySetup'));
const Receive = lazy(() => import('./receive'));
const SelectChain = lazy(() => import('./selectChain'));
const Signup = lazy(() => import('./signup'));
const WalletInfo = lazy(() => import('./walletInfo'));
const WalletInfoTitle = lazy(() => import('./walletInfo/title'));
const Walletconnect = lazy(() => import('./walletconnect'));

export enum RoutePath {
  Signup = 'signup',
  Connectors = 'connectors',
  Captcha = 'captcha',
  Connecting = 'connecting',
  DownloadApp = 'download-app',
  SelectChain = 'select-chain',
  Walletconnect = 'walletconnect',
  WalletInfo = 'wallet-info',
  Receive = 'receive',
  PasskeySetup = 'passkey-setup',
  LoginPasskey = 'login-passkey',
}

export const safeRoutes = {
  connected: [RoutePath.WalletInfo, RoutePath.Receive],
  disconnected: [
    RoutePath.Signup,
    RoutePath.Connectors,
    RoutePath.Captcha,
    RoutePath.Connecting,
    RoutePath.DownloadApp,
    RoutePath.SelectChain,
    RoutePath.Walletconnect,
    RoutePath.PasskeySetup,
    RoutePath.LoginPasskey,
  ],
};

export const allRoutes = [...safeRoutes.connected, ...safeRoutes.disconnected] as const;

export interface IPage {
  title?: TransactionKey | FC;
  path: RoutePath;
  element: FC<any>;
}

export const pages: IPage[] = [
  {
    title: 'signupTitle',
    path: RoutePath.Signup,
    element: Signup,
  },
  {
    title: 'connectorsTitle',
    path: RoutePath.Connectors,
    element: Connectors,
  },
  {
    title: 'captchaTitle',
    path: RoutePath.Captcha,
    element: Captcha,
  },
  {
    path: RoutePath.Connecting,
    element: Connecting,
  },
  {
    path: RoutePath.DownloadApp,
    element: DownloadApp,
  },
  {
    title: 'scanWithPhone',
    path: RoutePath.Walletconnect,
    element: Walletconnect,
  },
  {
    title: 'selectChainTitle',
    path: RoutePath.SelectChain,
    element: SelectChain,
  },
  {
    title: WalletInfoTitle,
    path: RoutePath.WalletInfo,
    element: WalletInfo,
  },
  {
    title: 'receive',
    path: RoutePath.Receive,
    element: Receive,
  },
  {
    title: 'setupPasskey',
    path: RoutePath.PasskeySetup,
    element: PasskeySetup,
  },
  {
    title: 'usePasskeyToLogin',
    path: RoutePath.LoginPasskey,
    element: LoginPasskey,
  },
] as const;

export const getPage = (path: RoutePath): IPage => {
  const page = pages.find((item) => item.path === path);
  if (!page) {
    throw new Error('route path undefined');
  }

  return page;
};
